<template>
  <div class="pa-6 text-center" role="alert">
    <v-icon color="warning" size="36">mdi-cloud-alert</v-icon>
    <p class="my-4">{{ message }}</p>
    <v-btn color="green" variant="tonal" @click="$emit('retry')">Try again</v-btn>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'LoadError',
  props: { message: { type: String, required: true } },
  emits: ['retry']
};
</script>
